import { useSyncExternalStore } from 'react';

// A text being typed, kept outside React state. The field subscribes (useDraft) and is
// the only thing that renders on a keystroke; whoever sends the text reads it when it
// needs it (`get`). Setting it from outside the field (a suggestion, a transcript, a
// reset) reaches the field through the subscription.
export function createDraft(initial = '') {
  let value = initial;
  const listeners = new Set();
  return {
    get: () => value,
    set: next => {
      if (next === value) return;
      value = next;
      listeners.forEach(listener => listener());
    },
    subscribe: listener => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}

const NONE = createDraft('');

// The draft's current text; `fallback` when there is no draft (the field is controlled).
export default function useDraft(draft, fallback = '') {
  const store = draft || NONE;
  const value = useSyncExternalStore(store.subscribe, store.get);
  return draft ? value : fallback;
}
